import PropTypes from 'prop-types'

export default function Navbar(prop) {

  let center={
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    gap:"1rem"
  }


  
    return(
        <>
        <nav style={prop.light}>
          <h2 className="navHeading">Text Editor</h2>
          <ul className='navbarLists' >
            <li><a href="/" className='anchors' style={prop.light}>Home</a></li>
          </ul>
          <div className='color-palette'>
            <div onClick={prop.purpleModeEnable}></div>
            <div onClick={prop.blueModeEnable}></div>
            <div onClick={prop.greenModeEnable}></div>
            <div  onClick={prop.orangeModeEnable}></div>
          </div>
          <div className="form-check form-switch" style={center}>
            <input className="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" onClick={prop.darkModeEnable}/> 
            <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Switch Mode</label>
          </div>
        </nav><hr/>
        </>
    );
};

Navbar.propTypes = {
    title: PropTypes.string.isRequired,
  };

Navbar.defaultProps = {
    title: 'Rafay Farhan',
  };